// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListNavigation-root-qaX_9 {
  margin: 0;
}

.ListNavigation-headerPosition-tLjxg {
  width: 100%;
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  line-height: normal;
}

@supports (-webkit-touch-callout: none) {
  .ListNavigation-headerPosition-tLjxg {
    top: 10px;
  }
}

@media screen and (max-width: 1200px) {
  @supports (-webkit-touch-callout: none) {
    .ListNavigation-headerPosition-tLjxg {
      top: 13px;
      padding: 0 12px;
    }
  }
}

@media screen and (max-width: 767px) {
  .ListNavigation-hideSm-L6Ijb {
    display: none !important;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Header/List/ListNavigation.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE;MACE,SAAS;MACT,eAAe;IACjB;EACF;AACF;;AAGA;EACE;IACE,wBAAwB;EAC1B;;AAEF","sourcesContent":[".root {\n  margin: 0;\n}\n\n.headerPosition {\n  width: 100%;\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 0;\n  line-height: normal;\n}\n\n@supports (-webkit-touch-callout: none) {\n  .headerPosition {\n    top: 10px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  @supports (-webkit-touch-callout: none) {\n    .headerPosition {\n      top: 13px;\n      padding: 0 12px;\n    }\n  }\n}\n\n\n@media screen and (max-width: 767px) {\n  .hideSm {\n    display: none !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ListNavigation-root-qaX_9`,
	"headerPosition": `ListNavigation-headerPosition-tLjxg`,
	"hideSm": `ListNavigation-hideSm-L6Ijb`
};
module.exports = ___CSS_LOADER_EXPORT___;
